const isEmployerRoute = (): boolean => location.pathname.split("/").includes("employer");

export default isEmployerRoute;
